import { setBaBaseConfig } from '@/utils/ba'

const userInfoHandler = function (userInfo) {
  if (userInfo && Object.keys(userInfo).length > 0) {
    setBaBaseConfig({
      userInfo,
    })
  }
}

export const baMixin = {
  watch: {
    '$store.getters.userInfo': {
      handler: userInfoHandler,
      immediate: true,
    },
  },
}
